import React, { useEffect } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAlert } from 'models/alertContext';
import { ActionTypes } from 'state/actions/alert';
import { Alert } from 'components/atoms/Alert';
import { Box } from '@mui/material';
import { Elabels, getBreadcrumbsBasic } from '../helpers';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ERouteLinks } from 'models/route';
import { ICaseFormValues } from 'models/cases';
import { ETabId } from 'pages/CaseManagementPage';
import { useCase } from '../hooks';
import { isPathEqualToRouteName } from 'utils/route';
import { useQuery } from 'hooks/useQuery';
import CaseAddForm, { EAddCaseType } from '../CaseAddForm';
import { ECaseProcessTypes } from 'constants/CaseProcessTypes';

const CaseAddPage = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { id = '' } = useParams<{ id: string }>();
  const query = useQuery();
  const type: string | null = query.get('type')?.trim() || null;
  const { clearAlert, samePageAlert } = useAlert();
  const { handleCreateCase, handleCreateOtherCase } = useCase();
  const { pathname }: any = useLocation();
  const isFromLE = isPathEqualToRouteName(pathname, ERouteLinks.LegalEntityCaseAddPage);

  const submitForm = async (data: ICaseFormValues) => {
    let caseId = null;
    if (data.processTypeUniqueId === ECaseProcessTypes.APPLICATION) {
      caseId = await handleCreateCase(data);
    }
    if (data.processTypeUniqueId === ECaseProcessTypes.OTHER_REQUEST) {
      caseId = await handleCreateOtherCase(data);
    }

    if (caseId) {
      navigate(
        isFromLE
          ? `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':id', id as string).replace(':caseId', caseId as string)}?type=${type}`
          : `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseId as string)}?expand=${ETabId.applications}`,
      );
    }
  };
  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_SAME_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const breadcrumbs = getBreadcrumbsBasic(isFromLE, type, t, false, id);

  const backLink = () => {
    isFromLE
      ? navigate(
          `${ERouteLinks.ViewLegalEntity.replace(
            ':id',
            id as string,
          )}?type=${type}&expand=cases`,
        )
      : navigate(`${ERouteLinks.CaseManagementPage}?expand=${ETabId.applications}`);
  };

  return (
    <>
      <Breadcrumbs items={[...breadcrumbs, t(Elabels.addCase)]} />
      <StyledPageTitle variant="h4">{t(Elabels.addCase)}</StyledPageTitle>
      <CaseAddForm
        LegalEntityid={id}
        caseType={EAddCaseType.APPLICATION}
        isFromLE={isFromLE}
        type={type}
        submitForm={submitForm}
        backLink={backLink}
      />
    </>
  );
};

export default CaseAddPage;
